module.exports = __webpack_public_path__ + "img/icon_submit.68b1e745.svg";